module.exports = __webpack_public_path__ + "static/media/class_job_027.5998c46a.svg";